import request from '@/utils/request'
import store from '@/store'
const userType = () => store.state.root.userInfo ? store.state.root.userInfo.type : ''
const getUserType = () => {
  switch (userType()) {
    case 'Account':
      return 'accounts'
    case 'User':
      return 'users'
    default:
      return ''
  }
}
export default {
  // 登入
  userLogin (fromData) {
    return request.post('/sign_in.json', { user: fromData })
  },
  // 重啟帳號
  reactivateAccount (verificationCode) {
    return request.post(`/reverify?verification_code=${verificationCode}`)
  },
  // 重設密碼申請
  resetPassword (email) {
    return request.post(`/users/password.json`, { user: { email } })
  },
  updatePassword (userData) {
    const { oldpw, newpw, confirmpw } = userData
    return request.put(`/${getUserType()}.json`, {
      [`${userType().toLowerCase()}`]: {
        current_password: oldpw,
        password: newpw,
        password_confirmation: confirmpw
      }
    })
  },
  // 取得User資料
  getUserInfo (token) {
    return request.get(`/activity_info?access_token=${token}`)
  }
}
